// The API writes dates in UTC but serializes them without a timezone marker ("2026-09-23T13:22:13.1234567").
// JavaScript reads such a string as LOCAL time, which pushed the sync marker 4 hours ahead on US phones.
// Treat a zone-less date-time as UTC, and trim sub-millisecond digits some browsers refuse to parse.
const HAS_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;
const DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

export const parseServerDate = (value: string | Date | null | undefined): number => {
    if (value === null || value === undefined || value === '') return NaN;
    if (value instanceof Date) return value.getTime();
    let s = String(value).trim().replace(/(\.\d{3})\d+/, '$1');
    if (DATE_TIME.test(s) && !HAS_ZONE.test(s)) s += 'Z';
    return Date.parse(s);
};
